import React, { useEffect, useState } from "react";
import api from "../../Utils/Axios";
import { toast } from "react-toastify";

const AdminJobsList = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        const res = await api.get("/api/admin/jobs");
        setJobs(res.data.jobs || []);
      } catch (err) {
        toast.error("Failed to load jobs");
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  const approveJob = async (jobId) => {
    try {
      await api.patch(`/api/admin/jobs/${jobId}/approve`);
      setJobs((prev) =>
        prev.map((job) => (job._id === jobId ? { ...job, status: "Live" } : job))
      );
      toast.success("Job approved");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to approve job");
    }
  };

  return (
    <div className="col-lg-12">
      <div className="table-wrapper2">
        <div className="title-and-btn">
          <div className="title">
            <h4>All Hospital Jobs</h4>
          </div>
        </div>
        {loading ? (
          <p>Loading jobs...</p>
        ) : (
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Title</th>
                <th>Hospital</th>
                <th>Category</th>
                <th>Status</th>
                <th>Billing</th>
                <th>Cost (USD)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length === 0 ? (
                <tr>
                  <td colSpan="6">No jobs found.</td>
                </tr>
              ) : (
                jobs.map((job) => (
                  <tr key={job._id}>
                    <td>{job.title}</td>
                    <td>{job.hospitalName}</td>
                    <td>{job.category || "-"}</td>
                    <td>{job.status}</td>
                    <td>{job.billingType}</td>
                  <td>{job.postCost || 0}</td>
                  <td>
                    {String(job.status).toLowerCase() === "pending" ? (
                      <button
                        className="primry-btn-2"
                        onClick={() => approveJob(job._id)}
                      >
                        Verify
                      </button>
                    ) : (
                      <span>-</span>
                    )}
                  </td>
                </tr>
              ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminJobsList;
